// Mirrors PendingUpload.MaxSizeInBytes in the backend
export const maxDocumentSizeInMegabytes = 500;
export const maxDocumentSizeInBytes = maxDocumentSizeInMegabytes * 1024 * 1024;

// Mirrors AiLimits.MaxDocumentSizeInBytes in the backend
export const maxAiDocumentSizeInBytes = 50 * 1024 * 1024;
